import { useCallback, useState } from 'react';
import { getStockLogo } from './image';
import { ERROR_LOGO_URL, getPublicAssetUrl } from "utils/objectStorage";

const useHandleImageError = () => {
    const handleImageError = useCallback(
        (event: React.SyntheticEvent<HTMLImageElement>, exchange?: string) => {
            const target = event.target as HTMLImageElement;

            if (exchange === "KOSPI") {
                // target.src = '/images/logos/KOSPI.svg';
                target.src = getPublicAssetUrl('logos/KOSPI.svg');
            } else if (exchange === "KOSDAQ") {
                // target.src = '/images/logos/KOSDAQ.svg';
                target.src = getPublicAssetUrl('logos/KOSDAQ.svg');

            } else {
                // target.src = '/images/logos/errorLogo.png';
                target.src = ERROR_LOGO_URL;
            }
        },
        []
    );

    return handleImageError;
};

export const useHandleImageErrorVer2 = () => {
    const [erroredTickers, setErroredTickers] = useState<Record<string, boolean>>(
        {}
    );
    const getStockLogoSafe = (ticker: string) => {
        return erroredTickers[ticker]
            ? ERROR_LOGO_URL
            : getStockLogo(ticker)
    }
    const onError = (ticker: string) => {
        setErroredTickers((prev) => ({
            ...prev,
            [ticker]: true,
        }));
    }

    return {
        getStockLogoSafe,
        onError
    };
};



export default useHandleImageError